"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDragdrop = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8.234 7.848a2 2 0 101.532-3.696 2 2 0 00-1.532 3.696zm1.532 2.304a2.001 2.001 0 10-1.533 3.698 2.001 2.001 0 001.533-3.697zm0 6a2.001 2.001 0 10-1.533 3.698 2.001 2.001 0 001.533-3.698zm4.469-8.304a2 2 0 101.531-3.696 2 2 0 00-1.531 3.696zm1.53 2.304a2.001 2.001 0 10-1.532 3.698 2.001 2.001 0 001.532-3.697zm0 6a2.001 2.001 0 10-1.532 3.698 2.001 2.001 0 001.532-3.698z' }))); };
exports.default = SvgDragdrop;
//# sourceMappingURL=Dragdrop.js.map